import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from "primereact/checkbox";
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { fetchTaxYearOptions, getSelectedTaxYear, includeSelectedTaxYearOption } from "./common/taxSelection";
import { getDataApi1, loadApi, saveApi, loadApi1, saveApi1} from "../services/appApi";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const Rentals  = () => {

  let emptyRow = {
    client_rental_id: null,                                                                   
    client_id: null,                                                                          
    tax_year: null,                                                                           
    account_owner_lkcd: "",                                                                   
    rental_name: "",                                                                          
    rental_address1: "",                                                                      
    rental_city: "",                                                                          
    rental_state: "",                                                                         
    rental_zip: "",                                                                           
    rental_county: "",                                                                        
    rental_description: "", 
    };

  const emptyDtlRow = {
    business_legal_name: null,
    client_first_name: "",
    client_id: null,
    client_last_name: null,
    client_middle_name: null,
    client_type_lkcd: "",
    firm_id: null,
    inc_exp_description: null,
    inc_exp_name: "",
    rental_1_amount: null,
    rental_1_name: "",
    rental_2_amount: null,
    rental_2_name: "",
    rental_3_amount: null,
    rental_3_name: "",
    rental_4_amount: null,
    rental_4_name: "",
    rental_5_amount: null,
    rental_5_name: null,
    rental_6_amount: null,
    rental_6_name: null,
    rental_7_amount: null,
    rental_7_name: null,
    rental_8_amount: null,
    rental_8_name: null,
    rental_9_amount: null,
    rental_9_name: null,
    rental_10_amount: null,
    rental_10_name: null,
    rental_inc_exp_type_lkcd: "",
    sort_seq: null,
    tax_year: null,
    total_no_of_rentals: null,
    rental_all_amount: null
  }

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [expandedRows, setExpandedRows] = useState([]);
  const [clientRentalsPivotSum, setClientRentalsPivotSum] = useState({});
  const [dtlRow, setDtlRow] = useState(emptyDtlRow);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [loadingRowId1, setLoadingRowId1] = useState(null);
  const [filters, setFilters] = useState({
    client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
    tax_year: {value: null, matchMode: FilterMatchMode.IN,}
  });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const dt1 = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);
  const [currentMode, setCurrentMode] = useState(''); 
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [taxYearDropdownOptions, setTaxYearDropdownOptions] = useState([]);
  const [fetchClientFlag, setFetchClientFlag] = useState(false);
  const userId = localStorage.getItem("taxUserId");
  const selectedClientId = localStorage.getItem("taxSelectedClientId");
  const selectedTaxYear = localStorage.getItem("taxSelectedTaxYear") || null;
  const firmId = localStorage.getItem("taxFirmId");
  const getNewRow = () => ({ ...emptyRow, client_id: selectedClientId, client_first_name: localStorage.getItem("taxSelectedClientName") || "", tax_year: getSelectedTaxYear() });

  useEffect(() => {
    fetchTaxYearOptions().then(setTaxYearDropdownOptions).catch(() => setTaxYearDropdownOptions([]));
  }, []);
    const fetchRows = async () => {
      try {
        if (!selectedClientId) {
          setRows([]);
          setIsLoading(false);
          return;
        }
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_client_rentals_pivot_v/v1/?p_client_id=${encodeURIComponent(selectedClientId)}&p_user_id=${encodeURIComponent(userId || "")}&p_tax_year=${encodeURIComponent(selectedTaxYear ?? "")}&offset=${offset}&limit=${limit}`);
        allData = [...allData, ...response.data.o_return_data_rc];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
         if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };
    useEffect(() => {
                      const fetchClient = async () => {
                        setFetchClientFlag(true);
                        try {
                          let offset = 0;
                          let limit = 25;
                          let hasMore = true;
                          let allData = [];
                          let status = null;
                          while (hasMore) {
                            const response = await getDataApi1(
                              `/ztx_firm_clients_v/v1/?p_user_id=${encodeURIComponent(userId || "")}&p_firm_id=${encodeURIComponent(firmId || "")}&offset=${offset}&limit=${limit}`,
                            );
                            allData = [...allData, ...response.data.o_return_data_rc];
                            status = response.status;
                            hasMore = response.data.hasMore;
                            offset = offset + limit;
                          }
                          if (allData.length > 0) {
                            const options = allData.map((item) => ({
                              label: item.client_first_name,
                              value: String(item.client_id),
                            }));
                            setClientNameOptions(options);
                            console.log(options);
                            setFetchClientFlag(false);
                          }
                        } catch (err) {
                          console.error(err);
                          setFetchClientFlag(false);
                        }
                      };
                      fetchClient();
                    }, []);
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const rental1NameBodyTemplate = (rowData) => {
    return rowData.rental_1_name ? rowData.rental_1_name.substring(0, 10) : null;
  };
   const rental2NameBodyTemplate = (rowData) => {
    return rowData.rental_2_name ? rowData.rental_2_name.substring(0, 10) : null;
  };
   const rental3NameBodyTemplate = (rowData) => {
    return rowData.rental_3_name ? rowData.rental_3_name.substring(0, 10) : null;
  };
   const rental4NameBodyTemplate = (rowData) => {
    return rowData.rental_4_name ? rowData.rental_4_name.substring(0, 10) : null;
  };
   const rental5NameBodyTemplate = (rowData) => {
    return rowData.rental_5_name ? rowData.rental_5_name.substring(0, 10) : null;
  };
  const numSortSeqTemplate = (rowData) => {
    return (rowData.sort_seq || rowData.sort_seq === 0) ? numeral(rowData.sort_seq).format('0,0') : null;
  };
  const numRentalAllAmountTemplate = (rowData) => {
    return (rowData.rental_all_amount || rowData.rental_all_amount === 0) ? numeral(rowData.rental_all_amount).format('0,0.00') : null;
  };
  const numRental1AmountTemplate = (rowData) => {
    return (rowData.rental_1_amount || rowData.rental_1_amount === 0) ? numeral(rowData.rental_1_amount).format('0,0.00') : null;
  };
  const numRental2AmountTemplate = (rowData) => {
    return (rowData.rental_2_amount || rowData.rental_2_amount === 0) ? numeral(rowData.rental_2_amount).format('0,0.00') : null;
  };
  const numRental3AmountTemplate = (rowData) => {
    return (rowData.rental_3_amount || rowData.rental_3_amount === 0) ? numeral(rowData.rental_3_amount).format('0,0.00') : null;
  };
  const numRental4AmountTemplate = (rowData) => {
    return (rowData.rental_4_amount || rowData.rental_4_amount === 0) ? numeral(rowData.rental_4_amount).format('0,0.00') : null;
  };
  const numRental5AmountTemplate = (rowData) => {
    return (rowData.rental_5_amount || rowData.rental_5_amount === 0) ? numeral(rowData.rental_5_amount).format('0,0.00') : null;
  };

  const rental1NameBody = row.rental_1_name ? row.rental_1_name.substring(0, 10) : null;
  const rental2NameBody = row.rental_2_name ? row.rental_2_name.substring(0, 10) : null;
  const rental3NameBody = row.rental_3_name ? row.rental_3_name.substring(0, 10) : null;
  const rental4NameBody = row.rental_4_name ? row.rental_4_name.substring(0, 10) : null;
  const rental5NameBody = row.rental_5_name ? row.rental_5_name.substring(0, 10) : null;
  const numSortSeq = (dtlRow.sort_seq || dtlRow.sort_seq === 0)  ? numeral(dtlRow.sort_seq).format('0,0') : null;
  const numRental1Amount = (dtlRow.rental_1_amount || dtlRow.rental_1_amount === 0)  ? numeral(dtlRow.rental_1_amount).format('0,0.00') : null;
  const numRental2Amount = (dtlRow.rental_2_amount || dtlRow.rental_2_amount === 0) ? numeral(dtlRow.rental_2_amount).format('0,0.00') : null;
  const numRental3Amount = (dtlRow.rental_3_amount || dtlRow.rental_3_amount === 0) ? numeral(dtlRow.rental_3_amount).format('0,0.00') : null;
  const numRental4Amount = (dtlRow.rental_4_amount || dtlRow.rental_4_amount === 0) ? numeral(dtlRow.rental_4_amount).format('0,0.00') : null;
  const numRental5Amount = (dtlRow.rental_5_amount || dtlRow.rental_5_amount === 0) ? numeral(dtlRow.rental_5_amount).format('0,0.00') : null;

  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

   const showNewProduct = () => {
    setRow(getNewRow());
    setCurrentMode('I');
    setShowProductDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R');
    setShowProductDialog(true);
}

const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U');
    setShowProductDialog(true);
  };

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">Rentals Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      Rentals
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}

      {/* <Button
        // label="New"
        icon="pi pi-plus"
        className="p-button-success p-button-rounded p-mr-2"
        onClick={showNewProduct}
        tooltip="New"
        tooltipOptions={{ position: "bottom" }}
      /> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );

  // const showDtlNewProduct = () => {
  //   setDtlRow(emptyRow);
  //   setCurrentDtlMode('I');
  //   setShowProductDtlDialog(true);
  // };

  const showDtlProduct = (dtlRow) => {
    setDtlRow({ ...dtlRow });
    // setCurrentDtlMode('R');
    setShowProductDtlDialog(true);
  }

  // const showDtlEditProduct = (row) => {
  //   setDtlRow({ ...dtlRow }); 
  //   setCurrentDtlMode('U');
  //   setShowProductDtlDialog(true);
  // };


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const editBodyTemplate = (rowData) => {
          return (
            <React.Fragment>
              <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-button-secondary"
                onClick={() => showEditProduct(rowData)}
                tooltip="Edit"
                tooltipOptions={{ position: "bottom" }}
              />
            </React.Fragment>
          );
      };

  const dtlReadBodyTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-eye"
            className="p-button-rounded p-button-primary"
            onClick={() => showDtlProduct(rowData)}
            tooltip="View"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
    };

    // const dtlEditBodyTemplate = (rowData) => {
    //       return (
    //         <React.Fragment>
    //           <Button
    //             icon="pi pi-pencil"
    //             className="p-button-rounded p-button-secondary"
    //             onClick={() => showEditProduct(rowData)}
    //             tooltip="Edit"
    //             tooltipOptions={{ position: "bottom" }}
    //           />
    //         </React.Fragment>
    //       );
    //   };

  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const taxYearOptions = [...new Set(rows.map((item) =>  item.tax_year).filter(Boolean)),].map((tax_year) => ({
    label: tax_year, value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

  const taxYearFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={taxYearOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Tax Year"
    display="chip" showClear/>
  )
  
  const fetchClientRentalsPivotSum = async (tax_year, client_first_name) => {
    setIsLoading1(true);
    setLoadingRowId(tax_year);
    setLoadingRowId1(client_first_name)
    try {
      let offset = 0;
      let limit = 25;
      let hasMore = true;
      let allData1 = [];
      let status = null;
      while (hasMore) {
      const response = await getDataApi1(
        `/ztx_client_rentals_pivot_sum_v/?offset=${offset}&limit=${limit}&q={"tax_year":${tax_year},"client_first_name":"${client_first_name}"}`
      );
        allData1 = [...allData1, ...response.data.items];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
    }

      if (allData1.length > 0) {
          setClientRentalsPivotSum((prevClientRentalsPivotSum) => ({
            ...prevClientRentalsPivotSum,
            [`${tax_year}-${client_first_name}`]: allData1,
          }));
          setIsLoading1(false);
      } else {
        setClientRentalsPivotSum((prevClientRentalsPivotSum) => ({ ...prevClientRentalsPivotSum, [`${tax_year}-${client_first_name}`]: [] }));
        setIsLoading1(false);
      }
    } catch (error) {
      setErrorMessage(error.message);
      setErrorDialogVisible(true);
    } finally {
      setIsLoading1(false);
      setLoadingRowId(null);
      setLoadingRowId1(null);
    }
  };

  useEffect(() => {
    const prevExpanded = prevExpanRef.current;
      const newlyExpanded = expandedRows.filter(
        (item) => !prevExpanded.some(
          (prevItem)=> prevItem.tax_year === item.tax_year && 
                      prevItem.client_first_name === item.client_first_name
        )
      )
      newlyExpanded.forEach((item) => {
      if(item.tax_year && item.client_first_name) {
        fetchClientRentalsPivotSum(item.tax_year, item.client_first_name);
      }
    });
    prevExpanRef.current = expandedRows;
  }, [expandedRows])

   const saveData = async (currentMode) => {
        if(currentMode === 'I') {
        try {
          const p_param = {
              p_user_id: userId,                                                                          
              p_client_id: row.client_id,                                                                 
              p_tax_year: row.tax_year,                                                                   
              p_account_owner_lkcd: row.account_owner_lkcd,                                               
              p_rental_name: row.rental_name,                                                             
              p_rental_address1: row.rental_address1,                                                     
              p_rental_city: row.rental_city,                                                             
              p_rental_state: row.rental_state,                                                           
              p_rental_zip: row.rental_zip,                                                               
              p_rental_county: row.rental_county,                                                         
              p_rental_description: row.rental_description, 
          };
          console.log("Insert p_param: ", p_param);
          const response = await loadApi1(
            p_param,
            "/ztx_client_rentals/v1/",
          );
          console.log(response);
          console.log(response.data);
          if (response.data.o_success_flag === "Y") {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: "Data Inserted",
            });
            const newRow = {
             client_rental_id: response.data.o_client_rental_id,
              ...row,
            };
            setRows((prev) => [...prev, newRow]);
            setShowProductDialog(false);
            setCurrentMode('');
            setRow(emptyRow);
          } else {
            const err_msg = response.data.o_return_msg;
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Data Not Inserted",
              life: 3000,
              width: "600px",
            });
            setErrorMessage(err_msg);
            setErrorDialogVisible(true);
          }
        } catch (error) {
          if (axios.isCancel(error) || error.name == "CanceledError") {
            toast.current.show({
              severity: "warn",
              summary: "Cancelled",
              detail: "Request successfully cancelled by the user.",
              life: 3000,
            });
          } else {
            // Set the error message and display the dialog
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
          }
        }
      } else if (currentMode === 'U'){
    
         const p_param = {                                                                              
              p_user_id: userId,                                                                                  
              p_client_rental_id: row.client_rental_id,                                                   
              p_client_id: row.client_id,                                                                 
              p_tax_year: row.tax_year,                                                                   
              p_account_owner_lkcd: row.account_owner_lkcd,                                               
              p_rental_name: row.rental_name,                                                             
              p_rental_address1: row.rental_address1,                                                     
              p_rental_city: row.rental_city,                                                             
              p_rental_state: row.rental_state,                                                           
              p_rental_zip: row.rental_zip,                                                               
              p_rental_county: row.rental_county,                                                         
              p_rental_description: row.rental_description,                                                                       
        
         };    
       
        console.log("Edit p_param: ", p_param);
        try {
          const response = await saveApi1(
            p_param,
            `/ztx_client_rentals/v1/`,
          );
          console.log(response);
          if (response.data.o_success_flag === "Y") {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: "Data Updated",
            });
            setRows((prev) =>
              prev.map((data) =>
                data.client_rental_id === row.client_rental_id
                  ? { ...row }
                  : data,
              ),
            );
            setShowProductDialog(false);
            setCurrentMode('');
          } else {
            const err_msg = response.data.o_return_msg;
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Data Not Updated",
              life: 3000,
              width: "600px",
            });
            setErrorMessage(err_msg);
          }
    
          //setRows(response.data);
        } catch (error) {
          if (axios.isCancel(error) || error.name == "CanceledError") {
            toast.current.show({
              severity: "warn",
              summary: "Cancelled",
              detail: "Request successfully cancelled by the user.",
              life: 3000,
            });
          } else {
            // Set the error message and display the dialog
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
          }
        }
      }
      };
 

  const drillDownTemplate = (rowData) => {
    const isExpanded = expandedRows.some((item) => item.tax_year === rowData.tax_year &&
                        item.client_first_name === rowData.client_first_name);

    return (
      <Button
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className={`p-button-rounded p-button-sm ${
          isExpanded ? "p-button-danger" : "p-button-primary"
        }`}
        onClick={() => toggleRowExpansion(rowData.tax_year, rowData.client_first_name)}
        tooltip="Detail"
        tooltipOptions={{ position: "bottom" }}
        style={{ fontSize: "1rem" }}
      />
    );
  };

  const toggleRowExpansion = (tax_year, client_first_name) => {
    setExpandedRows((prevExpandedRows) =>
      prevExpandedRows.some((item) => item.tax_year === tax_year &&
                                      item.client_first_name === client_first_name)
        ? prevExpandedRows.filter((item) =>
          !(item.tax_year === tax_year &&
            item.client_first_name === client_first_name
          )
        )
        : [...prevExpandedRows, {tax_year, client_first_name}]
    );
  };

  const rowExpansionTemplate = (data) => {
    const clientRentalsPivotSumData = clientRentalsPivotSum[`${data.tax_year}-${data.client_first_name}`] || [];
    const exportCSV1 = () => {
      dt1.current.exportCSV();
    };

    return (
      <div className="p-3">
        {loadingRowId == data.tax_year && loadingRowId1 == data.client_first_name && (<h4>The data is loading...</h4>)}
        {loadingRowId != data.tax_year && loadingRowId1 != data.client_first_name && (<>
        <div className="header-container">
          <div className="header-container p-1">
            <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
            <span className="p-input-icon-right w-full md:w-auto">
              <InputText
                type="search"
                onInput={(e) => setGlobalFilter1(e.target.value)}
                placeholder="Search..."
                className="w-full lg:w-auto text-sm p-3"
                style={{ fontSize: "17px" }}
              />
            </span>
            {/* <Button
              // label="New"
              icon="pi pi-plus"
              className="p-button-success p-button-rounded p-mr-2"
              onClick={showNewProductDtl}
              tooltip="New"
              tooltipOptions={{ position: "bottom" }}
            /> */}
            <Button
              icon="pi pi-upload"
              className="p-button-primary p-button-rounded"
              onClick={exportCSV1}
              tooltip="Export"
              tooltipOptions={{ position: "bottom" }}
              style={{ marginLeft: "20px", marginBottom: "10px" }}
            />
            <span style={{marginLeft: "20px"}}>
              <b>No. of Rows :</b> {clientRentalsPivotSumData.length}
            </span>
          </div>
        </div>
        <DataTable
          ref={dt1}
          value={clientRentalsPivotSumData}
          dataKey={`${clientRentalsPivotSumData.rental_inc_exp_type_lkcd}-${clientRentalsPivotSumData.inc_exp_name}`}
          responsiveLayout="scroll"
          globalFilter={globalFilter1}
          sortMode="multiple"
          multiSortMeta={[{field: "rental_inc_exp_type_lkcd", order: -1},
                          {field: "sort_seq", order: 1},
                          {field: "inc_exp_name", order: 1},
          ]}
        >
          <Column body={dtlReadBodyTemplate} exportable={false} headerStyle={{background: "#d3d3d3"}} bodyStyle={{background: "#f5f5f5"}} style={{width:'0.75rem' }}></Column>
          {/* <Column body={dtlEditBodyTemplate} exportable={false} headerStyle={{background: "#d3d3d3"}} bodyStyle={{background: "#f5f5f5"}} style={{width:'0.75rem' }}></Column> */}
          <Column field="rental_inc_exp_type_lkcd" header="Rent I/E" headerStyle={{background: "#d3d3d3"}} bodyStyle={{background: "#f5f5f5"}} sortable></Column>
          <Column field="sort_seq" header="Sort Seq" headerStyle={{background: "#d3d3d3"}} bodyStyle={{textAlign: "right", background: "#f5f5f5"}} body={numSortSeqTemplate} sortable></Column>
          <Column field="inc_exp_name" header="Inc Exp Name" headerStyle={{background: "#d3d3d3"}} bodyStyle={{background: "#f5f5f5"}} sortable></Column>
          <Column field="rental_all_amount" header="Rental All Amt" body={numRentalAllAmountTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{textAlign: "right", background: "#f5f5f5"}} sortable></Column>
          <Column field="rental_1_amount" header={data.rental_1_name ? data.rental_1_name.substring(0, 10) : "Rental 1"} body={numRental1AmountTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{textAlign: "right", background: "#f5f5f5"}} sortable></Column>
          <Column field="rental_2_amount" header={data.rental_2_name ? data.rental_2_name.substring(0, 10) : "Rental 2"} body={numRental2AmountTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{textAlign: "right", background: "#f5f5f5"}} sortable></Column>
          <Column field="rental_3_amount" header={data.rental_3_name ? data.rental_3_name.substring(0, 10) : "Rental 3"} body={numRental3AmountTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{textAlign: "right", background: "#f5f5f5"}} sortable></Column>
          <Column field="rental_4_amount" header={data.rental_4_name ? data.rental_4_name.substring(0, 10) : "Rental 4"} body={numRental4AmountTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{textAlign: "right", background: "#f5f5f5"}} sortable></Column>
          <Column field="rental_5_amount" header={data.rental_5_name ? data.rental_5_name.substring(0, 10) : "Rental 5"} body={numRental5AmountTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{textAlign: "right", background: "#f5f5f5"}} sortable></Column>
        </DataTable>
        </>
        )}
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">Rentals</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_rental_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
          expandedRows={expandedRows.map((item) =>
                rows.find((rows) => rows.tax_year === item.tax_year && rows.client_first_name === item.client_first_name)
              )}
          onRowToggle={(e) => {
            const rowData = e.data;
            setExpandedRows((prev) =>
              prev.some(
                (item) =>
                  item.tax_year === rowData.tax_year && 
                  item.client_first_name === rowData.client_first_name
              ) ? prev.filter(
                (item) => 
                  item.tax_year !== rowData.tax_year &&
                  item.client_first_name !== rowData.client_first_name
              ) : [
                ...prev,
                {
                  tax_year: rowData.tax_year,
                  client_first_name: rowData.client_first_name
                }
              ]
            );
          }}
          rowExpansionTemplate={rowExpansionTemplate}
        >
        
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          {/* <Column body={editBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column> */}
          <Column body={drillDownTemplate} style={{ width: "3rem", textAlign: "center" }}/>
          {/* <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterElement={clientFilterTemplate}></Column> */}
          <Column field="client_last_name" header="Last Name" sortable></Column>
          {/* <Column field="tax_year" header="Tax Year" filter showFilterMenu={false} filterElement={taxYearFilterTemplate} bodyStyle={{textAlign: "right"}} sortable></Column> */}
          <Column field="total_no_of_rentals" header="#OfRentals" bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="rental_1_name" header="Rental 1 Name" body={rental1NameBodyTemplate} sortable></Column>
          <Column field="rental_2_name" header="Rental 2 Name" body={rental2NameBodyTemplate} sortable></Column>
          <Column field="rental_3_name" header="Rental 3 Name" body={rental3NameBodyTemplate} sortable></Column>
          <Column field="rental_4_name" header="Rental 4 Name" body={rental4NameBodyTemplate}sortable></Column>
          <Column field="rental_5_name" header="Rental 5 Name" body={rental5NameBodyTemplate} sortable></Column>
        </DataTable>
      </div>
      )}

      {/* <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="Rentals" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="client_last_name">Last Name</label>
                    <div className="box">
                        {row.client_last_name}
                    </div>


                <label htmlFor="rental_1_name">Rental 1 Name</label>
                    <div className="box">
                        {rental1NameBody}
                    </div>
                <label htmlFor="rental_2_name">Rental 2 Name</label>
                    <div className="box">
                        {rental2NameBody}
                    </div>

                <label htmlFor="rental_3_name">Rental 3 Name</label>
                    <div className="box">
                        {rental3NameBody}
                    </div>

                <label htmlFor="rental_4_name">Rental 4 Name</label>
                    <div className="box">
                        {rental4NameBody}
                    </div>

                <label htmlFor="rental_5_name">Rental 5 Name</label>
                    <div className="box">
                        {rental5NameBody}
                    </div>

            </Dialog>*/}
            <Dialog visible={showProductDtlDialog} style={{ width: '37.5rem' }} header="Firm Clients" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="rental_inc_exp_type_lkcd">Rent I/E</label>
                    <div className="box">
                        {dtlRow.rental_inc_exp_type_lkcd}
                    </div>
                 <label htmlFor="sort_seq">Sort Seq</label>
                    <div className="box">
                        {numSortSeq}
                    </div>
                   <label htmlFor="inc_exp_name">Inc Exp Name</label>
                    <div className="box">
                        {dtlRow.inc_exp_name}
                    </div>
                     <label htmlFor="rental_1_amount">{dtlRow.rental_1_name ? dtlRow.rental_1_name.substring(0, 10) : "Rental 1"}</label>
                    <div className="box">
                        {numRental1Amount}
                    </div>
                    <label htmlFor="rental_2_amount">{dtlRow.rental_2_name ? dtlRow.rental_2_name.substring(0, 10) : "Rental 1"}</label>
                    <div className="box">
                        {numRental2Amount}
                    </div>
                    <label htmlFor="rental_3_amount">{dtlRow.rental_3_name ? dtlRow.rental_3_name.substring(0, 10) : "Rental 1"}</label>
                    <div className="box">
                        {numRental3Amount}
                    </div>
                    <label htmlFor="rental_4_amount">{dtlRow.rental_4_name ? dtlRow.rental_4_name.substring(0, 10) : "Rental 1"}</label>
                    <div className="box">
                        {numRental4Amount}
                    </div>
                    <label htmlFor="rental_5_amount">{dtlRow.rental_5_name ? dtlRow.rental_5_name.substring(0, 10) : "Rental 1"}</label>
                    <div className="box">
                        {numRental5Amount}
                    </div>
            </Dialog> 
            <Dialog
              // header="Add Rentals"
              header={currentMode === 'I' ? "Add Rentals" : currentMode === 'U' ? "Update Rentals" : currentMode === 'R' ? "View Rentals" : "Rentals"}
              visible={showproductDialog}
              style={{ width: "40rem" }}
              onHide={() => setShowProductDialog(false)}
            >
              <div className="p-fluid">
                <div className="field">
                  <label>Client</label>
                  <Dropdown
                    value={row.client_id ? String(row.client_id) : null}
                    disabled
                    options={clientNameOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Client"
                    onChange={(e) => {
                      const selectedOption = clientNameOptions.find(
                        (option) => option.value === e.value,
                      );
                      setRow({
                        ...row,
                        client_id: e.value,
                        client_first_name: selectedOption?.label || "",
                      });
                    }}
                  />
                </div>
                <div className="field">
                  <label>Tax Year</label>
                  <Dropdown
                    value={row.tax_year ? String(row.tax_year) : null}
                    disabled
                    options={includeSelectedTaxYearOption(taxYearDropdownOptions)}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Tax Year"
                    filter
                  />
                </div>

                <div className="field">
                  <label>Name</label>
                  <InputText
                    value={row.rental_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, rental_name: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Account Owner</label>
                  <InputText
                    value={row.account_owner_lkcd}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, account_owner_lkcd: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Address</label>
                  <InputText
                    value={row.rental_address1}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, rental_address1: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>State</label>
                  <InputText
                    value={row.rental_state}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, rental_state: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>City</label>
                  <InputText
                    value={row.rental_city}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, rental_city: e.target.value })}
                  />
                </div>
              
                <div className="field">
                  <label>Zip</label>
                  <InputText
                    value={row.rental_zip}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, rental_zip: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>County</label>
                  <InputText
                    value={row.rental_county}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, rental_county: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Description </label>
                  <InputTextarea value={row.rental_description} disabled = {currentMode === 'R' ? true : false} 
                    onChange={(e) => setRow({ ...row, rental_description: e.target.value })} rows={5} cols={30}
                  />
                </div>
                
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.5rem",
                  }}
                >
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    severity="secondary"
                    onClick={() => {
                      setShowProductDialog(false);
                      setRow(emptyRow);
                      setCurrentMode('');
                    }}
                  />
                  <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
                </div>
              </div>
            </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}} 
                onHide={hideDialog}
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default Rentals;